import React, { useState } from "react";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import { SpinnerCircular } from "spinners-react";
import arrowleft from "../assets/images/arrow-left.png";

export default function Permissions() {
  const token = GetStorage.get("xAuthToken");
  const [message, setMessage] = useState("");
  const [deleteSpin, setDeleteSpin] = useState(false);
  const [toggle, setToggle] = useState(true);

  const initialValues = {
    edit_team: false,
    edit_evo: false,
    edit_swimmer: false,
  };

  const onSubmit = async (values) => {
    setDeleteSpin(true);
    let { edit_team, edit_evo, edit_swimmer } = values;
    edit_team = edit_team ? 1 : 0;
    edit_evo = edit_evo ? 1 : 0;
    edit_swimmer = edit_swimmer ? 1 : 0;
    const newValues = { edit_team, edit_swimmer, edit_evo };
    console.log("value", newValues);
    http
      .put(`api/admin/permissions?token=${token}`, {
        edit_team: newValues.edit_team,
        edit_evo: newValues.edit_evo,
        edit_swimmer: newValues.edit_swimmer,
      })
      .then((res) => {
        console.log("response", res.data.message);
        setMessage(res.data.message);
        showToast("success", res.data.message);
        setDeleteSpin(false);
      })
      .catch((error) => {
        setDeleteSpin(false);

        console.log("error in dashbord---->", error.message);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav
          // sidebarClass={toggle ? "show" : "hide"}
          />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  {" "}
                  {/* <button
                    onClick={() => setToggle(!toggle)}
                    type="button"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button> */}
                  <h1>Permissions </h1>
                </div>
                {/* <h1> {message}</h1> */}

                <div className="user_profile   ">
                  <DropdownRight />
                </div>
              </div>
            </header>
            <div className="dashbord_content Permissions_text">
              <Formik
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ values, handleChange, handleBlur, handleSubmit }) => (
                  <>
                    <p>You can edit permissions of sub-admins as below.</p>
                    <form
                      // onSubmit={handleSubmit}
                      action="index_submit"
                      method="get"
                      className="Permissions_check_box mt-5"
                      accept-charset="utf-8"
                    >
                      <div className="form-group">
                        <label className="check_box">
                          {" "}
                          Allow admins to edit Evo orders?
                          <input
                            type="checkbox"
                            onChange={handleChange("edit_evo")}
                            onBlur={handleBlur("edit_evo")}
                            value={values.edit_evo}
                          />
                          <span className="checkmark"></span>{" "}
                        </label>
                      </div>
                      <div className="form-group">
                        <label className="check_box">
                          {" "}
                          Allow admins to change Team Settings
                          <input
                            type="checkbox"
                            onChange={handleChange("edit_team")}
                            onBlur={handleBlur("edit_team")}
                            value={values.edit_team}
                          />
                          <span className="checkmark"></span>{" "}
                        </label>
                      </div>
                      <div className="form-group">
                        <label className="check_box">
                          {" "}
                          Allow admins to edit swimmer info
                          <input
                            type="checkbox"
                            onChange={handleChange("edit_swimmer")}
                            onBlur={handleBlur("edit_swimmer")}
                            value={values.edit_swimmer}
                          />
                          <span className="checkmark"></span>{" "}
                        </label>
                      </div>

                      <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                        <button type="button" className=" them_btn_ouline  ">
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="them_btn "
                          onClick={handleSubmit}
                        >
                          {deleteSpin ? (
                            <SpinnerCircular className="button-spin" />
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </form>
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}
